import { FocusContext } from '@noriginmedia/norigin-spatial-navigation'
import React, { useEffect } from 'react'
import { useHybridFocusable } from '../../../hooks/useHybridFocusable'
import tts from '../../../lib/TTS'
import type { ChangeStationCarouselItemProps } from './types'

export default function ChangeStationCarouselItem({
  focusKey: focusKeyName,
  station,
  onEnterPress,
  onArrowPress,
}: ChangeStationCarouselItemProps) {
  const { ref, focused, focusKey } = useHybridFocusable({
    focusKey: focusKeyName,
    onEnterPress,
    onArrowPress,
  })

  const { common_name, address } = station

  useEffect(() => {
    if (focused) {
      tts.stopRead()
      tts.addTextToRead(`${common_name}. ${address}.`)
    }
  }, [focused, common_name, address])

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        ref={ref}
        className={`station-item-wrapper  ${focused ? 'focused' : ''}`}
      >
        <div className="station-item-title">{common_name}</div>
        <div className="station-item-address">{address}</div>
      </div>
    </FocusContext.Provider>
  )
}
